/**
 * @ngdoc directive
 * @name useragent
 *
 * @description
 * Page useragent
 */
module.directive('useragent', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            prefix: '@?',
            noOffline: '@?',
            type: '@?'
        },
        controller: ['$scope', '$rootScope', '$timeout', 'profile', '$q', function ($scope, $rootScope, $timeout, profile, $q) {
            $scope.ready = false;

            // retrieve live agent configuration
            $scope.config = {
                button_id: '',
                deployment_id: '',
                endpoint: '',
                orig_id: ''
            };

            var configRetriever = $q.defer();
            var $watcherSite = $rootScope.$watchCollection('config.site.live_agent', function(config) {
                angular.merge($scope.config, config);
                configRetriever.resolve();
            });

            // retrieve customer info
            var customer = profile.info;
            if (!profile.pending) {
                profile.claim();
            }
            profile.pending.promise
                .then(function () {
                    // be sure config is loaded
                    return configRetriever.promise;
                })
                .then(function () {
                    // remove config listener
                    $watcherSite();

                    // if liveagent is available, init it
                    if (liveagent) {
                        $scope.ready = true;

                        // add customer detail if available
                        if (customer.field_sfid) {
                            console.log('useragent: customer detected');
                            liveagent.addCustomDetail('ContactId', customer.field_sfid, true);
                            var prenom = customer.field_prenom ? customer.field_prenom : '';
                            var nom = customer.field_nom ? customer.field_nom : '';

                            liveagent.addCustomDetail('First Name', prenom);
                            liveagent.addCustomDetail('Last Name', nom);

                            //Display customer account in crc console
                            liveagent.findOrCreate('Contact')
                                .map('Id', 'ContactId', true, true, false)
                                .map('FirstName', 'First Name', false, false, true)
                                .map('LastName', 'Last Name', false, false, true)
                                .saveToTranscript('ContactId')
                                .showOnCreate();
                        } else {
                            console.log('useragent: no customer detected');
                        }

                        // init live agent
                        liveagent.init($scope.config.endpoint, $scope.config.deployment_id, $scope.config.orig_id)
                        
                        if (!window._laq) {
                            window._laq = [];
                        }
                        window._laq.push(function () {
                            if (liveagent) {
                                liveagent.showWhenOnline($scope.config.button_id, document.getElementById($scope.prefix + '_liveagent_button_online_' + $scope.config.button_id));
                            }
                        });
                    }
                });
            

            // button event handler
            $scope.startChat = function (button_id) {
                if (liveagent) {
                    liveagent.startChat($scope.config.button_id);
                }
            };

            // remove $watchers
            $scope.$on('$destroy', function () {
                $watcherSite();
            });
        }],
        templateUrl: 'src/components/useragent/useragent.html'
    };
});
